import { FileSpreadsheet, Globe, LayoutDashboard, Network, User } from "lucide-react";

const endUserNavigation = [
  {
    key: "/tenant/users/dashboard",
    icon: <LayoutDashboard className="icon" />,
    label: "Dashboard",
    navigate: "/tenant/users/dashboard",
  },
  {
    key: "/tenant/users/connections",
    icon: <Network className="icon" />,
    label: "Connections",
    navigate: "/tenant/users/connections",
  },
  {
    key: "/tenant/users/endpoint",
    icon: <Globe className="icon" />,
    label: "Endpoints",
    navigate: "/tenant/users/endpoint",
  },
  {
    key: "/tenant/users/policies",
    icon: <FileSpreadsheet className="icon" />,
    label: "Policies",
    navigate: "/tenant/users/policies",
  },
  {
    key: "/tenant/users/profile",
    icon: <User className="icon" />,
    label: "Profile",
    navigate: "/tenant/users/profile",
  }
];


export default endUserNavigation;
